import { render } from "./SelfLearning.vue?vue&type=template&id=538d2592"
import script from "./SelfLearning.vue?vue&type=script&lang=js"
export * from "./SelfLearning.vue?vue&type=script&lang=js"

import "./SelfLearning.vue?vue&type=style&index=0&id=538d2592&lang=css"

import exportComponent from "D:\\CY_selflearning\\self-learning\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__